export default {
  CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
  PUSH_USER_VALIDATION_ERRORS: 'PUSH_USER_VALIDATION_ERRORS',
  PUSH_USER: 'PUSH_USER',
  PUSH_USERS: 'PUSH_USERS',
  PUSH_USERS_BY_MASTER: 'PUSH_USERS_BY_MASTER',
  RESET_USER_STATE: 'RESET_USER_STATE',
  REPLACE_USER: 'REPLACE_USER',
  SET_IS_ADDING_OIT: 'SET_IS_ADDING_OIT',
  SET_IS_ADDING_USER: 'SET_IS_ADDING_USER',
  SET_IS_ADDING_USER_ADDRESS: 'SET_IS_ADDING_USER_ADDRESS',
  SET_IS_ADDING_USER_PHONE: 'SET_IS_ADDING_USER_PHONE',
  SET_IS_EDITING_USER: 'SET_IS_EDITING_USER',
  SET_IS_EDITING_USER_ADDRESSES: 'SET_IS_EDITING_USER_ADDRESSES',
  SET_IS_EDITING_USER_PHONES: 'SET_IS_EDITING_USER_PHONES',
  SET_IS_EDITING_USER_ROLES: 'SET_IS_EDITING_USER_ROLES',
  SET_SELECTED_USER_GUID: 'SET_SELECTED_USER_GUID',
  SET_USER_IS_LOADING: 'SET_USER_IS_LOADING',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_ACTIVE: 'UPDATE_USER_ACTIVE'
};
